import React from 'react';

import InputField from './InputField';
import { validatePhone } from '../validations/validations';

type PropsType = {
    name: string,
    label: string,
    value: string,
    required?: boolean,
    helperText?: string,
    sx?: {[key: string]: string | number },
    variant?: 'filled' | 'outlined' | 'standard',
    disabled?: boolean,
    onChange: (a: any) => void
};

export default function TextField(props: PropsType) {
    const { value } = props;

    const validations = [validatePhone({ value })];

    return (
        <InputField
            {...props}
            validations={validations}
        />
    );
}
